// get the auth'd user's following and followers subcollections' counts (usersPrivate)
// used in profilepage/ProfilePenpals
import {
  collection,
  query,
  orderBy,
  limit,
  startAfter,
  getDocs
} from 'firebase/firestore';
import { firestore } from '../firebase';
import { GET_MY_FOLLOWING, GET_MY_FOLLOWERS } from './types';

// get the followingCount doc in following subcollection of auth'd user (usersPrivate)
export const getMyFollowing = getNewMyFollowing => async (
  dispatch,
  getState
) => {
  try {
    const user = getState().auth.currentUser;
    const userID = user.uid;
    const currentMyFollowingList = getState().myPenpals.myFollowingList;

    const followingCollectionRef = collection(
      firestore,
      'usersPrivate',
      userID,
      'following'
    );
    const myFollowingQuery = query(
      followingCollectionRef,
      orderBy('createdAt', 'desc'),
      limit(10)
    );

    const currentLastMyFollowing = getState().myPenpals.lastMyFollowing;

    let modMyFollowingQuery;
    if (getNewMyFollowing) {
      modMyFollowingQuery = myFollowingQuery;
    } else {
      modMyFollowingQuery = query(
        followingCollectionRef,
        orderBy('createdAt', 'desc'),
        startAfter(currentLastMyFollowing),
        limit(10)
      );
    }

    const myFollowingSnapshot = await getDocs(modMyFollowingQuery);

    const myFollowingList = {};
    myFollowingSnapshot.docs.forEach(docSnap => {
      const data = docSnap.data();
      myFollowingList[docSnap.id] = { ...data };
    });

    let modMyFollowingList;
    if (getNewMyFollowing) {
      modMyFollowingList = { ...myFollowingList, ...currentMyFollowingList };
    } else {
      modMyFollowingList = { ...currentMyFollowingList, ...myFollowingList };
    }

    let lastMyFollowing;
    let moreMyFollowing;
    if (getNewMyFollowing && currentLastMyFollowing) {
      lastMyFollowing = currentLastMyFollowing;
      const currentMoreMyFollowing = getState().myPenpals.moreMyFollowing;
      moreMyFollowing = currentMoreMyFollowing;
    } else {
      lastMyFollowing =
        myFollowingSnapshot.docs[myFollowingSnapshot.docs.length - 1];
      if (myFollowingSnapshot.docs.length === 10) {
        moreMyFollowing = true;
      } else {
        moreMyFollowing = false;
      }
    }

    dispatch({
      type: GET_MY_FOLLOWING,
      payload: {
        myFollowingList: modMyFollowingList,
        lastMyFollowing,
        moreMyFollowing
      }
    });
  } catch (error) {
    console.error(error);
  }
};

// export const removeMyFollowingReduxState = () => async dispatch => {};

// get the followersCount doc in the followers subcollection of auth'd user (usersPrivate)
export const getMyFollowers = getNewMyFollowers => async (
  dispatch,
  getState
) => {
  try {
    const user = getState().auth.currentUser;
    const userID = user.uid;
    const currentMyFollowersList = getState().myPenpals.myFollowersList;

    const followersCollectionRef = collection(
      firestore,
      'usersPrivate',
      userID,
      'followers'
    );
    const myFollowersQuery = query(
      followersCollectionRef,
      orderBy('createdAt', 'desc'),
      limit(10)
    );

    const currentLastMyFollower = getState().myPenpals.lastMyFollower;

    let modMyFollowersQuery;
    if (getNewMyFollowers) {
      modMyFollowersQuery = myFollowersQuery;
    } else {
      modMyFollowersQuery = query(
        followersCollectionRef,
        orderBy('createdAt', 'desc'),
        startAfter(currentLastMyFollower),
        limit(10)
      );
    }

    const myFollowersSnapshot = await getDocs(modMyFollowersQuery);
    const myFollowersList = {};
    myFollowersSnapshot.docs.forEach(docSnap => {
      const data = docSnap.data();
      myFollowersList[docSnap.id] = { ...data };
    });

    let modMyFollowersList;
    if (getNewMyFollowers) {
      modMyFollowersList = { ...myFollowersList, ...currentMyFollowersList };
    } else {
      modMyFollowersList = { ...currentMyFollowersList, ...myFollowersList };
    }

    let lastMyFollower;
    let moreMyFollowers;
    if (getNewMyFollowers && currentLastMyFollower) {
      lastMyFollower = currentLastMyFollower;
      const currentMoreMyFollowers = getState().myPenpals.moreMyFollowers;
      moreMyFollowers = currentMoreMyFollowers;
    } else {
      lastMyFollower =
        myFollowersSnapshot.docs[myFollowersSnapshot.docs.length - 1];
      if (myFollowersSnapshot.docs.length === 10) {
        moreMyFollowers = true;
      } else {
        moreMyFollowers = false;
      }
    }

    dispatch({
      type: GET_MY_FOLLOWERS,
      payload: {
        myFollowersList: modMyFollowersList,
        lastMyFollower,
        moreMyFollowers
      }
    });
  } catch (error) {
    console.error(error);
  }
};

// export const removeMyFollowersReduxState = () => async dispatch => {};
